<template>
  <div>
    <button @click="replaceTextLines" style="background-color: #4CAF50; color: white;">文章を変更</button>
    <br>
    <div v-if="firstLine" style="margin-bottom: 10px; font-weight: bold;">
      {{ firstLine }}
      <button @click="copyFirstLine" style="background-color: #2196F3; color: white;">
        {{ copyFirstLineButtonText }}
      </button>
    </div>
    <br>
    <button @click="copyToClipboard" style="background-color: #ff5722; color: white;">
      {{ copyTemplateButtonText }}
    </button>
    <div style="white-space: pre-wrap;">{{ extractedTextHtml }}</div>
  </div>
</template>

<script>
import newText from './PrivacyProtection/newText';

export default {
  data() {
    return {
      termsOfServiceText: `
<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="fund-settlement">
      <Title jpn="Descrizione basata sulla legge sui servizi di pagamento" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Nome della società operativa</span>
            <span class="text">Xero Place Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">persona rappresentativa</span>
            <span class="text">Yuki Narita</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Indirizzo di registrazione della società/indirizzo dell'ufficio commerciale</span>
            <span class="text">123-0865</span>
            <span class="text">3-10-1 LEO-HOUSE302, Nitta, Adachi-ku, Tokyo</span>
            <span class="text">3-10-1 LEO-HOUSE302, Nitta, Adachi-ku, Tokyo</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Limite/durata di proprietà della moneta (valuta su questo sito).</span>
            <span class="text">Non esiste un limite massimo per le monete.</span>
            <span class="text">Tuttavia, se sono trascorsi 6 mesi (incluso un giorno) dall'ultimo utilizzo dei Coin senza utilizzarli dopo l'acquisto o lo scambio di Coin, potremmo eliminare il tuo account senza avvisarti in anticipo.</span>
            <span class="text">In questo caso la Moneta non sarà più valida.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Intervallo di posizioni di utilizzo delle monete</span>
            <span class="text">Non esiste un limite massimo per le monete.</span>
            <span class="text">Le monete (valuta all'interno di questo sito) possono essere utilizzate all'interno dell'account registrato.</span>
            <span class="text">Inoltre, è vietato il trasferimento di account e il trasferimento di monete.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Precauzioni per l'uso</span>
            <span class="text">Le monete (valuta all'interno di questo sito) non possono essere rimborsate.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Come controllare le monete che possiedi</span>
            <span class="text">Puoi verificarlo sullo schermo di questo sito.</span>
            <span class="text">Se c'è qualche movimento nelle monete che possiedi, il numero cambierà automaticamente.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Informazioni sui contatti</span>
            <span class="text">Vi preghiamo di contattarci qui.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">termini di servizio</span>
            <span class="text">Si prega di verificare i termini di utilizzo di questo sito.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>
      `,
      newText,
      extractedTextHtml: [],
      firstLine: '',
      copyFirstLineButtonText: 'firstLineをコピー',
      copyTemplateButtonText: 'templateをコピー',
    };
  },
  mounted() {
    this.replaceTextLines();
  },
  methods: {
    getTextLines() {
      this.extractedTextHtml = this.termsOfServiceText;
      console.log('抽出されたHTML（タグ含む）:', this.extractedTextHtml);
    },
    replaceTextLines() {
      // newTextを改行で分割し、最初の1行を削除する
      const lines = this.newText.split('\n').filter((line) => line.trim() !== '');
      this.firstLine = lines.shift();
      let lineIndex = 0;
      // <Title jpn="ここ" />をfirstLineで置換
      let replacedHtml = this.termsOfServiceText.replace(
        /(<Title jpn=")([^"]*)(" \/>)/,
        (match, openTag, innerText, closeTag) => `${openTag}${this.firstLine}${closeTag}`,
      );

      // spanタグの中身を新しい行で置き換える
      replacedHtml = replacedHtml.replace(
        /(<span class="text">)([\s\S]*?)(<\/span>)/g,
        (match, openTag, innerText, closeTag) => {
          const replacement = lines[lineIndex] ? lines[lineIndex].trim() : innerText;
          lineIndex += 1;
          return `${openTag}${replacement}${closeTag}`;
        },
      );

      this.extractedTextHtml = replacedHtml;
    },
    // 以下、一行目削除しない場合
    replaceTextLinesWithoutRemovingFirstLine() {
      const lines = this.newText.split('\n').filter((line) => line.trim() !== '');
      let lineIndex = 0;

      this.extractedTextHtml = this.termsOfServiceText.replace(
        /(<span class="text">)([\s\S]*?)(<\/span>)/g,
        (match, openTag, innerText, closeTag) => {
          const replacement = lines[lineIndex] ? lines[lineIndex].trim() : innerText;
          lineIndex += 1;
          return `${openTag}${replacement}${closeTag}`;
        },
      );
    },
    copyToClipboard() {
      const trimmedText = this.extractedTextHtml.trim();
      navigator.clipboard.writeText(trimmedText)
        .then(() => {
          this.copyTemplateButtonText = 'コピーしました！';
          setTimeout(() => { this.copyTemplateButtonText = 'templateをコピー'; }, 2000);
        })
        .catch((error) => {
          console.error('コピーに失敗しました:', error);
        });
    },
    copyFirstLine() {
      navigator.clipboard.writeText(this.firstLine)
        .then(() => {
          this.copyFirstLineButtonText = 'コピーしました！';
          setTimeout(() => { this.copyFirstLineButtonText = 'firstLineをコピー'; }, 2000);
        })
        .catch((error) => {
          console.error('コピーに失敗しました:', error);
        });
    },
  },
};
</script>
